<template>
    <div id="contenedor-principal-consulta" class="container-fluid">
        <!-- SECCION DE ENCABEZADOS -->
        <div id="encabezados">
            <h1>CONSULTA CRITERIOS PENALES</h1>
            <h4>Consulta los criterios penales</h4>
            <div class="hr-titulo"></div>
        </div>
        <!-- SECCION DE CONSULTA -->
        
            <!----------------------------------------------AQUI EMPEZAMOS NUEVO ORDEN-------------------------------------------------------------------->
                        
                        <!------------------------------------------------------------------------------------------------------------------>
                        <div class="contenedor-color-negro col area">                                    
                            <!-- PARAMETROS PARA LA RESOLUCION DE AMPARO -->
                            <div class="form-group row ">
                                <div class="col">
                                    <h6>Consecutivo Amparo</h6>
                                            <div class="input-group">
                                                <div class="input-group-append">
                                                    <div class="input-group-text"><i class="fa fa-folder"></i></div>
                                                </div>
                                                <input class="form-control input-sm input-xs input-md input-lg py-2 border-left-0 border" type="text" v-model="tablaCriterios.filtros.numExpediente" v-mask="'####/####'" placeholder="####/####">
                                            </div>
                                </div>
                                <div  class="col">
                                    <h6>Consecutivo Toca Oral</h6>
                                            <div class="input-group">
                                                <div class="input-group-append">
                                                    <div class="input-group-text"><i class="fa fa-folder"></i></div>
                                                </div>
                                                <input class="form-control input-sm input-xs input-md input-lg py-2 border-left-0 border" type="text" v-model="tablaCriterios.filtros.numExpedienteToca" v-mask="'####/####'" placeholder="####/####">
                                            </div>
                                </div>
                                <div  class="col">
                                    <h6>Magistrado</h6>
                                            <div class="input-group">
                                                <CCatalogoGenerico class="p-0 m-0" 
                                                    v-on:valorParaElPadre="evtCambioMagistrado" 
                                                    :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                                    :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                                    :idDelInput="'CMagistrados'" 
                                                    :elementosCatalogo="tablaCriterios.filtros.magistrados.listmagistrados"
                                                    :textoOpcionesSingular="'magistrado'">
                                                </CCatalogoGenerico>
                                            </div>
                                </div>
                                <div  class="col">
                                    <h6>Tipo De Procedencia</h6>
                                            <div class="input-group">
                                                <CCatalogoGenerico class="p-0 m-0" 
                                                    v-on:valorParaElPadre="evtCambioTipoDeProcedencia" 
                                                    :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                                    :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                                    :idDelInput="'CTipoDeProcedencia'" 
                                                    :elementosCatalogo="tablaCriterios.filtros.tipoDeProcedencia.listtipodeprocedencia"
                                                    :textoOpcionesSingular="'procedencia'">
                                                </CCatalogoGenerico>
                                            </div>
                                </div>
                                <div  class="col">
                                    <h6>Año</h6>
                                    <div class="input-group">
                                        <CCatalogoGenerico class="p-0 m-0" 
                                            v-on:valorParaElPadre="evtCambioAnio" 
                                            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                            :idDelInput="'CAnio'" 
                                            :elementosCatalogo="tablaCriterios.filtros.anios.lstanios"
                                            :textoCompletoSingular="'Año'"
                                            :conOpcionDeinstrucciones="false">
                                        </CCatalogoGenerico>
                                    </div>
                                </div>
                            </div>   
                            <div id="seccion-acciones" class="form-group justify-content-start col-2">
                                <button type="button" @click="BusquedaDeCriterios" class="form-control btn btn-primary mr-4"><i class="fas fa-search"></i>&nbsp;&nbsp;Buscar</button>
                            </div>                         
                        </div>
                        <!------------------------------------------------------------------------------------------------------------------>
                           
                            
                                <div class="area">
                                    <!------------------------------------------------------------------------------------------------------------------>
                                        <table
                                                class="table table-light table-hover table-respons"
                                                :id="tablaCriterios.ID"              
                                                data-toggle="table"
                                                data-pagination="true"
                                                data-maintain-selected="true"  
                                                data-page-size = "10"
                                                data-page-list="[5,10,20]"
                                                data-click-to-select="false"
                                                data-show-toggle="false"
                                                data-show-pagination-switch="true"
                                                data-search="true">
                                                <thead class="thead-dark">
                                                    <tr>
                                                        <th data-halign="center" data-width="8" data-align="center" data-field="DocumentoPadreID">
                                                            Folio
                                                        </th>
                                                        <th data-halign="center" data-width="8" data-align="center" data-field="AmparoExp">
                                                            Amparo
                                                        </th>
                                                        <th data-halign="center" data-width="8" data-align="center" data-field="TocaOral">
                                                            TocaOral
                                                        </th>
                                                        <th data-halign="center" data-width="11" data-align="center" data-field="TipoResolucion">
                                                            Resolucion 
                                                        </th>
                                                        <th data-halign="center" data-width="8" data-align="center" data-field="TipoDeProcedencia">
                                                            Tipo
                                                        </th>
                                                        <th data-halign="center" data-width="10" data-align="center" data-field="Magistrado">
                                                            Magistrado
                                                        </th>
                                                        <th data-halign="center" data-width="23" data-align="justify" data-field="ObservacionR">
                                                            Observacion
                                                        </th>
                                                        <th data-width="10" data-halign="center" data-align="center" data-field="viewExtracto" data-events="operateEventsE">
                                                            Extracto
                                                        </th>
                                                        <th data-width="10" data-halign="center" data-align="center" data-field="viewResolucion" data-events="operateEventsR">
                                                            Resolucion
                                                        </th>
                                                        <th data-width="10" data-halign="center" data-align="center" data-field="editarCriterio" data-events="operateEventsU">
                                                            Acciones
                                                        </th>
                                                    </tr>
                                                </thead>
                                        </table>    
                                    <!------------------------------------------------------------------------------------------------------------------>    
                                </div>
                        <!------------------------------------------------------------------------------------------------------------------>  
                                        <div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                                            <div class="modal-dialog modal-lg">
                                                <div class="modal-content">
                                                    <div class="col-12">
                                                        <div id="visor_contenedor">                        
                                                            <div id="visor_archivo">                                                 
                                                            <PDFDocument  :height="'750px'" :url="urlDoc" :key="rendervisor"/>
                                                            </div>
                                                        </div>   
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                        <!------------------------------------------------------------------------------------------------------------------>  
                        <!----------------------------------------------AQUI TERMINA NUEVO ORDEN-------------------------------------------------------------------->
    </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import sistemas from '@/../static/js/sistemas'
import comun from "@/../static/js/comun"
import api from '@/../static/js/api'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
import PDFDocument from '@/../src/components/Comunes/PDFDocument'
import CCatalogoGenerico from '@/../src/components/SICPE/Comun/CCatalogoGenerico'
import VueMask from 'v-mask'
import router from '@/router/index'

Vue.use(VueMask);
export default {
    data() {
      return {
        rendervisor: -1,
        urlDoc: "",
        enumeraciones,
        usuarioUpdate: false,
        tablaCriterios: {
                ID: 'Tabla-criterios-penales',
                criterios: [],
                filtros: {
                            tipoDeProcedencia: {
                                listtipodeprocedencia: [],
                                tipoDeProcedenciaId: -1
                            },
                            magistrados: {
                                listmagistrados: [],
                                UsuarioId: -1
                            },
                            anios: {
                                lstanios:[],
                                anioid: -1,
                                aniostring: '',
                            },
                            numExpediente: '',
                            numExpedienteToca: ''
                        }
        }
    }
    },
    components: {
        PDFDocument,
        CCatalogoGenerico
    },
    computed:{
    },
    methods: {
         /**
         * Funcion encargada de llamar a servicio REST para obtener las cedul
         * @param {Object} peticion [valor correspondiente al objeto POST del servicio REST]
         * @param {Boolean} conMensajeDeRespuesta [valor correspondiente a la validacion para mostrar mensaje en el sistema con la respuesta de la peticio del servicio REST]
         */
         obtenerCAnio: async function() { 
            let procesoSinError = false;
            
            try {
                let anios= {
                        "Selectanio":[
                                            {"llave":"-1", "valor":"Seleccione el año"},
                                            {"llave":"2020", "valor":"2020"},
                                            {"llave":"2021", "valor":"2021"},
                                            {"llave":"2022", "valor":"2022"}
                                    ]
                        };
                    this.tablaCriterios.filtros.anios.lstanios = anios.Selectanio;
            }
            catch(excepcion) {
                console.log(excepcion);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
            return procesoSinError;
         },
        /**
         * Funcion encargada de llamar a servicio REST para obtener las cedul
         * @param {Object} peticion [valor correspondiente al objeto POST del servicio REST]
         * @param {Boolean} conMensajeDeRespuesta [valor correspondiente a la validacion para mostrar mensaje en el sistema con la respuesta de la peticio del servicio REST]
         */
         obtenerCTipoDeProcedencia: async function() { 
            let procesoSinError = false;
            let peticion = {};
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = "SICPE/Registro/GetTipoDeProcedencia";/**api.SICPE.catalogos.catalogos.Cat_TipoResolucion;"SICPE/Catalogo/GetTipodeResolucion"*/
                const URL_API_SERVICIO = SERVIDOR + METODO_API_OBTENER;
                const HEADER_PETICION = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false,false);
                comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_SOLICITUD = await axios.post(URL_API_SERVICIO, peticion, HEADER_PETICION);
                const DATOS_RESPUESTA = await RESPUESTA_SOLICITUD.data;
                let { SiHayError, Error, TipoDeProcedencia, Satisfactorio } = DATOS_RESPUESTA;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    console.log(Error);
                    comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(mensajeError);
                    await Promise.resolve(this.inicializarTabla({ elementos: [] }));
                } 
                else {
                    this.tablaCriterios.filtros.tipoDeProcedencia.listtipodeprocedencia = TipoDeProcedencia.map(pDB => {
                      let procedenciaObj = { ...pDB };
                      procedenciaObj.valor = pDB.Nombre
                      procedenciaObj.llave = pDB.TipoDeProcedenciaId
                      return procedenciaObj;
                    });
                    procesoSinError = true;
                }
                    comun.SeEstaCargandoInformacion(false);
                
            }
            catch(excepcion) {
                console.log(excepcion);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
            return procesoSinError;
        },
        /**
         * Funcion encargada de llamar a servicio REST para obtener las cedul
         * @param {Object} peticion [valor correspondiente al objeto POST del servicio REST]
         * @param {Boolean} conMensajeDeRespuesta [valor correspondiente a la validacion para mostrar mensaje en el sistema con la respuesta de la peticio del servicio REST]
         */
         obtenerCMagistrados: async function() { 
            let procesoSinError = false;
            let peticion = {};
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = "SICPE/Registro/GetMagistrados";/**api.SICPE.catalogos.catalogos.Cat_TipoResolucion;"SICPE/Catalogo/GetTipodeResolucion"*/
                const URL_API_SERVICIO = SERVIDOR + METODO_API_OBTENER;
                const HEADER_PETICION = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false,false);
                comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_SOLICITUD = await axios.post(URL_API_SERVICIO, peticion, HEADER_PETICION);
                const DATOS_RESPUESTA = await RESPUESTA_SOLICITUD.data;
                let { SiHayError, Error, Magistrados, Satisfactorio } = DATOS_RESPUESTA;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    console.log(Error);
                    comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(mensajeError);
                    await Promise.resolve(this.inicializarTabla({ elementos: [] }));
                } 
                else {
                    this.tablaCriterios.filtros.magistrados.listmagistrados = Magistrados.map(mDB => {
                      let magistradoObj = { ...mDB };
                      magistradoObj.valor = mDB.NombreCompleto
                      magistradoObj.llave = mDB.UsuarioId
                      return magistradoObj;
                    });;
                    procesoSinError = true;
                }
                    comun.SeEstaCargandoInformacion(false);
                
            }
            catch(excepcion) {
                console.log(excepcion);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
            return procesoSinError;
        },
        evtCambioTipoDeProcedencia: function(evento) {
            this.tablaCriterios.filtros.tipoDeProcedencia.tipoDeProcedenciaId = parseInt(evento.target.value);
        },
        evtCambioMagistrado: function(evento) {
            this.tablaCriterios.filtros.magistrados.UsuarioId = parseInt(evento.target.value);
        },
        evtCambioAnio: function(evento)
        {
            
            this.tablaCriterios.filtros.anios.aniostring = parseInt(evento.target.value);
        },
        evtViewDocument: function(url)
        {
            this.urlDoc = url;
            this.rendervisor += 1;
        },
        evtEditCriterio: function(folio , toca)
        {
            let parametro1 = folio;
            let parametro2 = toca;
            router.push({ 
                name: "ResolucionAmparo", 
                params: { folio: parametro1 , tocaOral: parametro2 } 
            });
        },
        
        /**
         * Funcion encargada de llamar a servicio REST para obtener las cedul
         * @param {Object} peticion [valor correspondiente al objeto POST del servicio REST]
         * @param {Boolean} conMensajeDeRespuesta [valor correspondiente a la validacion para mostrar mensaje en el sistema con la respuesta de la peticio del servicio REST]
         */
         BusquedaDeCriterios: async function({conMensajeDeRespuesta = true }) { 
          //this.$ref['agregarRes'].amparoDocumentopadreId = this.numExpediente;
            let procesoSinError = false;
            let peticion = {};
            peticion.numExpediente = this.tablaCriterios.filtros.numExpediente;
            peticion.numExpedienteToca = this.tablaCriterios.filtros.numExpedienteToca;
            peticion.tipoDeProcedenciaId = this.tablaCriterios.filtros.tipoDeProcedencia.tipoDeProcedenciaId;
            peticion.MagistradoId = this.tablaCriterios.filtros.magistrados.UsuarioId;
            peticion.anio = this.tablaCriterios.filtros.anios.aniostring;
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = "SICPE/Consulta/GetCriteriosPenales";//api.SICPE.sistema.registro.consultaAmparos.ObtenerAmparos;
                const URL_API_SERVICIO = SERVIDOR + METODO_API_OBTENER;
                const HEADER_PETICION = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false,false);
                comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_SOLICITUD = await axios.post(URL_API_SERVICIO, peticion, HEADER_PETICION);
                const DATOS_RESPUESTA = await RESPUESTA_SOLICITUD.data;
                let { SiHayError, Error, CriterioPenal, Satisfactorio } = DATOS_RESPUESTA;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    console.log(Error);
                    comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(mensajeError);
                    await Promise.resolve(this.inicializarTabla({ elementos: [] }));
                } 
                else {
                    this.tablaCriterios.criterios = CriterioPenal.map(aDB => {
                      let amparoObj = { ...aDB };
                      amparoObj.viewResolucion = aDB.RutaResolucion != '' ? `<i data-toggle="modal" data-target=".bd-example-modal-lg" class ="fas fa-file-import viewdocumentR"></i>` : '';
                      amparoObj.viewExtracto = aDB.RutaExtracto != '' ? `<i data-toggle="modal" data-target=".bd-example-modal-lg" class ="fas fa-file-import viewdocumentE"></i>`: '';
                      amparoObj.editarCriterio = this.usuarioUpdate ? `<i class ="fas fa-sync-alt editCriterio"></i>` : 'No Disponible';
                      return amparoObj;
                    });
                    $('#Tabla-criterios-penales').bootstrapTable({ data: this.tablaCriterios.criterios });
                    $('#Tabla-criterios-penales').bootstrapTable('load', this.tablaCriterios.criterios);
                    procesoSinError = true;
                    console.log(this.tablaCriterios.criterios);
                }
                    comun.SeEstaCargandoInformacion(false);
                
            }
            catch(excepcion) {
                console.log(excepcion);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
            return procesoSinError;
        },/**
         * Funcion encargada de llamar a servicio REST para obtener las cedul
         * @param {Object} peticion [valor correspondiente al objeto POST del servicio REST]
         * @param {Boolean} conMensajeDeRespuesta [valor correspondiente a la validacion para mostrar mensaje en el sistema con la respuesta de la peticio del servicio REST]
         */
         UsuarioEditable: async function() { 
             console.log("STORE::" ,this.$store.state.Login_Usuario.UsuarioId);
            let procesoSinError = false;
            let peticion = {};
            peticion.UsuarioId = this.$store.state.Login_Usuario.UsuarioId;
            peticion.Funcion = 4;
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = "SICPE/Usuario/GetPermisosDelUsuario";//api.SICPE.sistema.registro.consultaAmparos.ObtenerAmparos;
                const URL_API_SERVICIO = SERVIDOR + METODO_API_OBTENER;
                const HEADER_PETICION = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false,false);
                comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_SOLICITUD = await axios.post(URL_API_SERVICIO, peticion, HEADER_PETICION);
                const DATOS_RESPUESTA = await RESPUESTA_SOLICITUD.data;
                let { SiHayError, Error, Permisos, Satisfactorio } = DATOS_RESPUESTA;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    console.log(Error);
                    //comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(mensajeError);
                    //await Promise.resolve(this.inicializarTabla({ elementos: [] }));
                } 
                else {
                    this.usuarioUpdate = Permisos;
                    procesoSinError = true;
                    console.log(this.usuarioUpdate);
                }
                    comun.SeEstaCargandoInformacion(false);
                
            }
            catch(excepcion) {
                console.log(excepcion);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
            return procesoSinError;
        }
      
    },
    created() {
        this.obtenerCMagistrados();
        this.obtenerCTipoDeProcedencia();
        this.obtenerCAnio();
        this.UsuarioEditable();
    },
    mounted(){
        window.operateEventsR = {'click .viewdocumentR': (e, value, row, index) => { 
            this.evtViewDocument(row.RutaResolucion);
        }},
        window.operateEventsE = {'click .viewdocumentE': (e, value, row, index) => { 
            this.evtViewDocument(row.RutaExtracto);
        }},
        window.operateEventsU = {'click .editCriterio': (e, value, row, index) => { 
            this.evtEditCriterio(row.DocumentoPadreID , row.TocaOral);
        }}
    }
  }
</script>
<style>
  #seccion-acciones .btn {
    padding: 0.3em 0.8em 0.3em 0.8em;
    font-size: 1.1em;
    background-color: black;
}
.table-respons {
    table-layout: fixed;
    width: 100%;
    word-wrap:break-word; 
}
</style>


// WEBPACK FOOTER //
// src/components/SICPE/Administracion/Consulta.vue